import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { VitalFlagCategory } from '../../models/vital_flags.model';

@Component({
  selector: 'app-measure-type',
  templateUrl: './measure-type.component.html',
  styleUrls: ['./measure-type.component.scss'],
})
export class MeasureTypeComponent implements OnInit {
  @Input()
  measureForm: UntypedFormGroup;

  categories = Object.values(VitalFlagCategory);

  constructor() {}

  ngOnInit(): void {}
}
